class ModalTrigger extends HTMLElement {
  constructor() {
    super();

    const url = this.dataset.url;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          Theme.Helpers.prefetch(url);
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(this);

    this.addEventListener("click", (event) => {
      event.preventDefault();

      fetch(url)
        .then(response => response.text())
        .then(text => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");

          document.dispatchEvent(new CustomEvent("modaltrigger:click", {
            detail: {
              content: doc.body.innerHTML
            }
          }));
        });
    });
  }
}

customElements.define("modal-trigger", ModalTrigger);

class ModalContent extends HTMLElement {
  constructor() {
    super();

    const elements = {
      overlay: this.querySelector("[data-local-overlay]"),
      close: this.querySelector("[data-local-close]"),
      content: this.querySelector("[data-local-dynamic-content]")
    };

    document.addEventListener("modaltrigger:click", (event) => {
      elements.content.innerHTML = event.detail.content;
      this.show();
    });

    elements.overlay.addEventListener("click", (event) => {
      this.hide();
    });

    elements.close.addEventListener("click", (event) => {
      this.hide();
    });
  }

  show() {
    this.classList.add("state--active");
  }

  hide() {
    this.classList.remove("state--active");
  }
}

customElements.define("modal-content", ModalContent);
